<script>
import goodsTopMenu from "@/components/goods/components/topMenu.vue";
import MassChangeBrand from "@/components/goods/massСhange/MassChangeBrand.vue";
export default {
  name: "massChange",
  components: {MassChangeBrand, goodsTopMenu},
  data(){
    return {

    }
  },

}
</script>

<template>
  <section class="goods-change">
    <goods-top-menu></goods-top-menu>
    <b-container fluid class="mb-5">
      <MassChangeBrand />
    </b-container>
  </section>
</template>

<style scoped>

</style>